// Import global utils
import { isEmpty } from '@automator/shared/utils/is-empty';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import apiFetch
import apiFetch from '@wordpress/api-fetch';

// We will improve the folder structure as we add components
import '@automator/builder/_legacy/js/item/conditions/components';
import '@automator/builder/_legacy/js/user-selector/components';

// Load walkthrough
import '@automator/builder/_legacy/js/walkthrough';

// Load static resources
// Import select2 (Dropdown)
// select2.org
import "select2/dist/css/select2.css";

// Import flatpickr (DatePicker)
// flatpickr.js.org
import "flatpickr/dist/flatpickr.min.css";

// Import main styles
import './scss/main.scss';

import {
	createDataOnLoad,
	handleFatalError,
	__deprecated__recipeObject
}   from './js/common/utilities.js';

import Publish            from './js/publish/publish.js';

import Triggers           from './js/item/triggers.js';
import Actions            from './js/item/actions.js';

import RecipeTitle        from './js/recipe/title';

import Taxonomies         from './js/taxonomies/taxonomies.js';

import RecipeNotes        from './js/recipe/notes';

if ( ! isEmpty(UncannyAutomator ) ) {
	// Create JS cache object
	UncannyAutomator._cache = {
		tokens: {},
	};

	// Expose transformation function globally for external integrations (e.g., MCP client)
	window.__deprecated__recipeObject = __deprecated__recipeObject;

	// Create the data required to render Automator
	try {
		createDataOnLoad(() => {
			// Once ready, render the UI
			new Triggers();
			new Actions();
			new Publish();
			new RecipeTitle();
			new Taxonomies();
			new RecipeNotes();
		});
	} catch ( error ){
		// Show a modal with data in case the UI couldn't load
		handleFatalError({
			title:   escapeHTML( __( 'The recipe creator could not be loaded', 'uncanny-automator' ) ),
			warning: escapeHTML( __( 'Sorry, something went wrong when loading the recipe interface. Technical details are listed below.', 'uncanny-automator' ) ),
			content: escapeHTML( __( 'Click Learn More for steps you can take to resolve this issue.', 'uncanny-automator' ) ),
			console: error
		});
	}

	document.addEventListener( 
		'uap-builder-recipe-data-change', 
		event => {
			new Triggers();
			new Actions();
			new Publish();

			// Set the title in the UI
			if ( UncannyAutomator._recipe.title ) {
				document.querySelector( 'input[name="post_title"] ').value = UncannyAutomator._recipe.title;
				document.querySelector( 'input[name="post_title"] ').dispatchEvent( new Event( 'input' ) );
			}
		} 
	);

	// Remove the "Changes you made may not be saved" WordPress alert
	jQuery( document ).ready( () => {
		jQuery( window ).off( 'beforeunload.edit-post', null );
	});		
}

/**
 * Temporary: Load chat launcher after recipe type is selected.
 *
 * The button is not rendered by PHP for new recipes (no recipe type yet),
 * so we fetch and insert it via AJAX after the type is confirmed.
 * This will be removed when the recipe type selector is removed.
 */
( function initChatLauncherAfterRecipeType() {
	// If recipe type is already set, PHP rendered the button - nothing to do
	if ( ! isEmpty( UncannyAutomator._recipe?.recipe_type ) ) {
		return;
	}

	// Add the nonce as middleware
	apiFetch.use( apiFetch.createNonceMiddleware(
		UncannyAutomatorBackend.rest.nonce
	) );

	// Listen for recipe type confirmation (fires AFTER the type is saved)
	document.addEventListener( 'uap/builder/core/set-recipe-type', () => {
		// Check if button already exists
		if ( document.querySelector( 'ua-chat-launcher' ) ) {
			return;
		}

		// Fetch the launcher HTML from the REST endpoint
		apiFetch( {
			url: `${ UncannyAutomatorBackend.rest.url }/mcp/chat/launcher/${ UncannyAutomator._recipe.recipe_id }`,
			method: 'GET',
		} ).then( response => {
			// Insert the launcher into the DOM
			if ( response?.html ) {
				document.querySelector( '#wpbody' ).insertAdjacentHTML( 'beforeend', response.html );
			}
		} ).catch( error => {
			// Silently fail - launcher is enhancement, not critical
			console.warn( 'Failed to load chat launcher:', error );
		} );
	} );
} )();